"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

var _EventSupport = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/EventSupport"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Swiper pointer action.
 */
var SwiperPointer = /*#__PURE__*/function (_EventHandler) {
  _inherits(SwiperPointer, _EventHandler);

  var _super = _createSuper(SwiperPointer);

  /**
   * Class constructor.
   *
   * @param {SwiperInfo} info Swiper info.
   * @param {SwiperRenderer} animation Swiper animation.
   * @param {SwiperPosition} position Swiper position.
   */
  function SwiperPointer(info, animation, position) {
    var _this;

    _classCallCheck(this, SwiperPointer);

    _this = _super.call(this, {
      supportedEvents: ['swipeStart', 'swipeEnd'],
      componentName: 'Swiper'
    });
    _this.scrollAngle = 45; // the breaking angle that determines if the swiper should swipe or if the page should scroll.

    _this.quickSwipeTime = 600; // The time in ms for when a quick swipe is done (always slide in a direction).

    _this.quickSwipeDistance = 150; // The minimal distance to swipe quickly to achieve a quick swipe.

    _this.swipeOffset = 20; // The amount of offset at begining and end.

    _this.acceleration = 500; // The amount of acceleration (a greater value will give increased acceleration).

    _this.moveOffset = 20; // The minimal distance in pixels to swipe before it should be considered as the Swiper is moving (block click and disable angle check).

    _this.pageSizeFactor = 0.5; // How much of a page that has to be swiped before it slides to it (number between 0 and 1).

    _this._info = info;
    _this._animation = animation;
    _this._position = position;
    _this._pointerPosition = {
      x: 0,
      y: 0
    };
    _this._pointerPositionStart = {
      x: 0,
      y: 0
    };
    _this._handlePointerDown = _this._handlePointerDown.bind(_assertThisInitialized(_this));
    _this._handlePointerMove = _this._handlePointerMove.bind(_assertThisInitialized(_this));
    _this._handlePointerUp = _this._handlePointerUp.bind(_assertThisInitialized(_this));
    _this._swipeStartTime = null;
    _this._isMoving = false;
    _this._isSwiping = false;
    _this._isConnected = false;
    _this._transitionTimeout = null;
    _this._animationFrame = null;
    return _this;
  }
  /**
   * Connects the pointer watcher.
   */


  _createClass(SwiperPointer, [{
    key: "connect",
    value: function connect() {
      if (!this._isConnected) {
        this._isConnected = true;

        this._addPointerEvents(_EventSupport.default.getSupportedPointerEvents());
      }
    }
    /**
     * Disconnects the pointer watcher.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this._isConnected) {
        this._isConnected = false;

        this._removePointerEvents(_EventSupport.default.getSupportedPointerEvents());

        this.reset();
      }
    }
    /**
     * Resets the pointer data.
     *
     * @param {boolean} cancelTransitions TRUE to cancel transitions. Default is TRUE.
     */

  }, {
    key: "reset",
    value: function reset() {
      var cancelTransitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this._isSwiping = false;
      this._isMoving = false;
      this._isPointerUp = false;

      if (cancelTransitions) {
        clearTimeout(this._transitionTimeout);
        window.cancelAnimationFrame(this._animationFrame);
        this._animationFrame = null;

        this._animation.cancelTransitions();
      }
    }
    /**
     * Handles pointer down event.
     *
     * @param {Event} event Fired event.
     */

  }, {
    key: "_handlePointerDown",
    value: function _handlePointerDown(event) {
      var isTouch = event.touches && event.touches.length > 0;

      if (!isTouch) {
        event.preventDefault();
      }

      if (this._position.getPages().length === 1) {
        return;
      }

      this.reset(false);
      this._isSwiping = true;
      this._pointerPositionStart = {
        x: (isTouch ? event.touches[0].pageX : event.clientX) * (this._info.rtl ? -1 : 1),
        y: isTouch ? event.touches[0].pageY : event.clientY
      };
      this._pointerPosition = this._pointerPositionStart;
      this._swipeStartTime = Date.now();
      this.trigger('swipeStart');
    }
    /**
     * Handles pointer move event.
     *
     * @param {Event} event Fired event.
     */

  }, {
    key: "_handlePointerMove",
    value: function _handlePointerMove(event) {
      var _this2 = this;

      if (!event.touches || this._isMoving || this._info.vertical) {
        event.preventDefault();
      }

      if (this._isSwiping) {
        var isTouch = event.touches && event.touches.length > 0;
        this._pointerPosition = {
          x: (isTouch ? event.touches[0].pageX : event.clientX) * (this._info.rtl ? -1 : 1),
          y: isTouch ? event.touches[0].pageY : event.clientY
        };

        if (this._animationFrame === null) {
          this._animationFrame = window.requestAnimationFrame(function () {
            var direction = _this2._info.vertical ? 'y' : 'x';
            var moveOffset = _this2._pointerPosition[direction] - _this2._pointerPositionStart[direction];

            var position = _this2._getPositionWithinBoundaries(moveOffset);

            _this2._animation.setPosition(position);

            _this2._animationFrame = null;

            if (!_this2._isMoving) {
              var angle = Math.abs(_this2._getAngle({
                x: _this2._pointerPositionStart.x,
                y: _this2._pointerPositionStart.y
              }, {
                x: _this2._pointerPosition.x,
                y: _this2._pointerPosition.y
              }));

              if (moveOffset < -1 * _this2.moveOffset || moveOffset > _this2.moveOffset) {
                _this2._isMoving = true;

                _this2._animation.startDragging();
              }

              if (_this2._isScrollAngle(angle) || _this2._isPointerUp) {
                _this2._handlePointerUp();
              }
            } else if (_this2._isPointerUp) {
              _this2._handlePointerUp();
            }
          });
        }
      }
    }
    /**
     * Handles pointer up event.
     *
     * @param {Event} event Fired event.
     */

  }, {
    key: "_handlePointerUp",
    value: function _handlePointerUp(event) {
      var _this3 = this;

      if (event && !event.touches) {
        event.preventDefault();
      }

      this._isPointerUp = true;

      if (this._isSwiping && this._animationFrame === null) {
        this.reset();
        var direction = this._info.vertical ? 'y' : 'x';

        var time = Date.now() - this._swipeStartTime;

        var swipedDistance = this._pointerPosition[direction] - this._pointerPositionStart[direction];

        var distance = this._getDistanceWithAcceleration(swipedDistance, time);

        this._animation.setEasing('ease-out');

        this._animation.endDragging();

        this._handleTransition(distance, function () {
          _this3._animation.transition();

          _this3.trigger('swipeEnd');
        });

        if (Math.abs(swipedDistance) > this.moveOffset) {
          this._handleSlide(distance, time);
        }
      }
    }
    /**
     * Handles sliding to previous/next page.
     *
     * @param {number} distance Swipe distance in pixels.
     * @param {number} time Time elapsed.
     */

  }, {
    key: "_handleSlide",
    value: function _handleSlide(distance, time) {
      var _this4 = this;

      var position = this._position;
      var newPosition = position.getPosition() + distance;
      var startPage = position.getPageIndex();
      var delta = distance < 0 ? 1 : -1;

      var isBeginingOrEnd = function isBeginingOrEnd() {
        return delta > 0 ? position.isEnd() : position.isBegining();
      };

      var shouldSlide = function shouldSlide() {
        return delta > 0 ? newPosition < _this4._getSlidePagePosition(delta) : newPosition > _this4._getSlidePagePosition(delta);
      };

      while (!isBeginingOrEnd() && shouldSlide()) {
        position.slide(delta);
      }

      if (time < this.quickSwipeTime && startPage === position.getPageIndex() && (delta > 0 ? distance < -1 * this.quickSwipeDistance : distance > this.quickSwipeDistance)) {
        position.slide(delta);
      }
    }
    /**
     * Handles transition.
     * When the distance is larger or smaller than the size of all items combined it will add an offset to give the impression of a bounce.
     *
     * @param {number} swipeDistance Swipe distance in pixels.
     * @param {Function} callback Callback to be called when done.
     */

  }, {
    key: "_handleTransition",
    value: function _handleTransition(swipeDistance, callback) {
      var position = this._position;
      var newPosition = position.getPosition() + swipeDistance;
      var pagePosition = swipeDistance < 0 ? position.getPositionAtPage(position.getPages().length - 1) : position.getPositionAtPage(0);
      var offsetSize = swipeDistance / this.swipeOffset;

      var isBeginingOrEnd = function isBeginingOrEnd() {
        return swipeDistance < 0 ? position.isEnd() : position.isBegining();
      };

      if (!isBeginingOrEnd() && (swipeDistance > 0 && newPosition > pagePosition || swipeDistance < 0 && newPosition < pagePosition)) {
        this._animation.transition(callback, this._animation.defaultTransitionTime * 0.5);

        this._animation.setPosition(pagePosition + offsetSize);
      } else {
        this._transitionTimeout = setTimeout(callback);
      }
    }
    /**
     * Checks if an angle is considered as scrolling.
     *
     * @param {number} angle Angle.
     * @returns {boolean} Angle.
     */

  }, {
    key: "_isScrollAngle",
    value: function _isScrollAngle(angle) {
      return angle !== 0 && this._info.vertical && angle < this.scrollAngle || !this._info.vertical && angle > this.scrollAngle;
    }
    /**
     * Returns the position of a page to slide to.
     *
     * @param {number} delta  Page delta.
     * @returns {number} Position.
     */

  }, {
    key: "_getSlidePagePosition",
    value: function _getSlidePagePosition(delta) {
      var position = this._position;
      return position.getPositionAtPage(position.getPageIndex() + delta) + position.getPageSize(position.getPageIndex() + delta) * (1 - this.pageSizeFactor) * delta;
    }
    /**
     * Returns position within boundaries.
     *
     * @param {number} distance Position.
     * @returns {number} Position within boundaries.
     */

  }, {
    key: "_getPositionWithinBoundaries",
    value: function _getPositionWithinBoundaries(distance) {
      var position = this._position.getPosition() + distance;

      if (distance !== 0) {
        var offsetSize = 4 * distance / this.swipeOffset;
        var lastPagePosition = this._position.getPositionAtPage(this._position.getPages().length - 1) + offsetSize;
        var firstPagePosition = this._position.getPositionAtPage(0) + offsetSize;

        if (position < lastPagePosition) {
          return lastPagePosition;
        }

        if (position > firstPagePosition) {
          return firstPagePosition;
        }
      }

      return position;
    }
    /**
     * Returns distance with acceleration.
     *
     * @param {number} swipeDistance Swipe distance.
     * @param {number} time Time elapsed.
     * @returns {number} Swipe distance.
     */

  }, {
    key: "_getDistanceWithAcceleration",
    value: function _getDistanceWithAcceleration(swipeDistance, time) {
      var easeOut = 1 / this._easeOutQuad(time / this.acceleration);

      return swipeDistance * (easeOut > 1 ? easeOut : 1);
    }
    /**
     * Ease out curve.
     *
     * @param {number} t Value.
     * @returns {number} Easing value.
     */

  }, {
    key: "_easeOutQuad",
    value: function _easeOutQuad(t) {
      return t * (2 - t);
    }
    /**
     * Returns the angle between two points.
     *
     * @param {object} p1 Point 1.
     * @param {number} p1.x X Value.
     * @param {number} p1.y Y Value.
     * @param {object} p2 Point 1.
     * @param {number} p2.x X Value.
     * @param {number} p2.y Y Value.
     * @returns {number} Angle.
     */

  }, {
    key: "_getAngle",
    value: function _getAngle(p1, p2) {
      return Math.atan2(Math.abs(p2.y - p1.y), Math.abs(p2.x - p1.x)) * 180 / Math.PI;
    }
    /**
     * Adds pointer events that are to be used for swiping.
     *
     * @param {{start: string, move: string, end: string, leave: string}[]} events Events object.
     */

  }, {
    key: "_addPointerEvents",
    value: function _addPointerEvents(events) {
      var wrapperElement = this._animation.getWrapperElement();

      var _iterator = _createForOfIteratorHelper(events),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var event = _step.value;
          wrapperElement.addEventListener(event.start, this._handlePointerDown);
          wrapperElement.addEventListener(event.move, this._handlePointerMove);
          wrapperElement.addEventListener(event.end, this._handlePointerUp);
          wrapperElement.addEventListener(event.leave, this._handlePointerUp);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Removes pointer events that are to be used for swiping.
     *
     * @param {{start: string, move: string, end: string, leave: string}[]} events Events object.
     */

  }, {
    key: "_removePointerEvents",
    value: function _removePointerEvents(events) {
      var wrapperElement = this._animation.getWrapperElement();

      var _iterator2 = _createForOfIteratorHelper(events),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var event = _step2.value;
          wrapperElement.removeEventListener(event.start, this._handlePointerDown);
          wrapperElement.removeEventListener(event.move, this._handlePointerMove);
          wrapperElement.removeEventListener(event.end, this._handlePointerUp);
          wrapperElement.removeEventListener(event.leave, this._handlePointerUp);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return SwiperPointer;
}(_EventHandler2.default);

exports.default = SwiperPointer;